import { SVGProps } from 'react'

export const DashboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5505 7.58887H4C2.61929 7.58887 1.5 6.46958 1.5 5.08887C1.5 3.70816 2.61929 2.58887 4 2.58887H13.5505M7.44949 18.5889H17C18.3807 18.5889 19.5 17.4696 19.5 16.0889C19.5 14.7082 18.3807 13.5889 17 13.5889H7.44949M1.5 16.0889C1.5 18.0219 3.067 19.5889 5 19.5889C6.933 19.5889 8.5 18.0219 8.5 16.0889C8.5 14.1559 6.933 12.5889 5 12.5889C3.067 12.5889 1.5 14.1559 1.5 16.0889ZM19.5 5.08887C19.5 7.02186 17.933 8.58887 16 8.58887C14.067 8.58887 12.5 7.02186 12.5 5.08887C12.5 3.15587 14.067 1.58887 16 1.58887C17.933 1.58887 19.5 3.15587 19.5 5.08887Z"
      stroke="#667085"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
